module.exports = __webpack_public_path__ + "static/media/print-list.978d5452.svg";